import { DetectedDateDetail, DetectedDatesSummary } from '../../../models/home';
import { MonitoredDateResponse, RoleSummaryResponse } from '../../../models/home/dtos';

export class DatesAdapter {
  static toSummaryViewModel(dto: RoleSummaryResponse[]): DetectedDatesSummary {
    const byRole: Record<string, number> = {};
    const roleLabels: Record<string, string> = {};
    const monitoredDates: DetectedDateDetail[] = [];

    dto.forEach((roleSummary) => {
      const roleKey = roleSummary.role ?? 'unknown';
      const documentsWithDate = roleSummary.documentsWithDate ?? 0;
      byRole[roleKey] = documentsWithDate;
      const roleLabel = roleSummary.displayName ?? roleSummary.roleDisplayName ?? roleKey;
      roleLabels[roleKey] = roleLabel;

      (roleSummary.monitoredDates ?? []).forEach((date) => {
        monitoredDates.push(DatesAdapter.mapMonitoredDate(date, roleKey, roleLabel));
      });
    });

    const totalDetected = Object.values(byRole).reduce((acc, value) => acc + value, 0);

    return {
      totalDetected,
      byRole,
      roleLabels,
      monitoredDates,
    };
  }

  private static mapMonitoredDate(
    date: MonitoredDateResponse,
    roleKey?: string | null,
    roleLabel?: string | null
  ): DetectedDateDetail {
    const documentName = date.documentTitle ?? DatesAdapter.formatDocumentLabel(date.documentId);
    const stateKey = date.dateState ?? 'active';
    return {
      id: date.documentId ?? 'unknown',
      documentName: documentName || 'Documento',
      role: roleKey ?? 'unknown',
      roleLabel: roleLabel ?? undefined,
      state: stateKey,
      stateLabel: date.dateStateDisplayName ?? undefined,
      dueDate: date.normalizedDate ?? '',
      owner: '',
      tooltip: '',
      triggerReason: '',
      queueItemId: date.queueItemId ?? undefined,
    };
  }

  private static formatDocumentLabel(documentId?: string | null): string {
    if (!documentId) return 'Documento';
    if (documentId.includes('.') || documentId.includes('_')) {
      return documentId;
    }
    const trimmed = documentId.trim();
    if (/^[0-9a-fA-F-]{8,}$/.test(trimmed)) {
      return 'Documento';
    }
    if (/^\d{6,}$/.test(trimmed)) {
      return 'Documento';
    }
    return documentId;
  }
}
